<cdk-virtual-scroll-viewport [ngStyle]="{'height': treeHeight}" #treeNodesVirtualScroll itemSize="40">
  <div *cdkVirtualFor="let node of renderedNodes">
    <div class="flat-tree-node" [class.background-indeterminate]="isBackgroundIndeterminate(node)" [class.filled-indeterminate]="isFilledIndeterminate(node)" [ngStyle]="{'padding-left': calculateNodePadding(node)}" (click)="selectable && !multiSelect ? onRadioNodeClick(node) : null">
      <lib-cdw-checkbox *ngIf="selectable && multiSelect" #treeCheckbox (checkedEmitter)="onCheckboxChange($event)" [value]="node" [checked]="getNodeChecked(node)" [indeterminate]="getNodeIndeterminate(node)"></lib-cdw-checkbox>
      <lib-cdw-radio-button *ngIf="selectable && !multiSelect" #treeRadio [value]="node.value" [checked]="getNodeChecked(node)" name="ouTreeRadio"></lib-cdw-radio-button>
      <button *ngIf="node.expandable"  (click)="onNodeExpanded(node); $event.stopPropagation()" mat-icon-button>
        <lib-cdw-icon [ngClass]="{
          'tree-expanded-icon': node.isExpanded,
          'tree-collapsed-icon': !node.isExpanded
          }" [fill]="true" icon="change_history" size="16px"></lib-cdw-icon>
      </button>
      <span [title]="node.value || node.displayName">{{node.displayName}}</span>
    </div>
  </div>
</cdk-virtual-scroll-viewport>
